import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import type { LessonAndAssessmentResult } from '../type';

import { apiCall } from 'hooks/service';

import { LEARNER_SCORE } from '../enum';

export const useLearnerScoreController = () => {
  const navigationTo = useNavigate();

  const params = useParams();

  const learnerId = params?.id;

  const location = useLocation();

  const classId = location.state?.classId;

  const [activeKey, setActiveKey] = useState<string>(LEARNER_SCORE.LESSONS);

  const [data, setData] = useState<LessonAndAssessmentResult>();

  useEffect(() => {
    if (!learnerId && !classId) {
      return;
    }

    getLearnResult();
  }, [learnerId, classId]);

  const getLearnResult = async () => {
    const result: LessonAndAssessmentResult = await apiCall({
      url: `/classes/${classId}/learners/${learnerId}/lessons-and-assessments`,
      method: 'GET',
      isLoading: true,
    });

    if (result) {
      setData(result);
    }
  };

  const onTabClick = (key: string) => {
    setActiveKey(key);
  };

  const goBack = () => {
    navigationTo(-1);
  };

  return { activeKey, onTabClick, goBack, data };
};
